// Centralized backend URL config — single source of truth instead of
// hardcoded fallbacks scattered across api.js/AuthContext.js/Bills.jsx/etc.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://saad-bin-shalwah-management-backend-3hku745k0.vercel.app';
export const API_URL = process.env.REACT_APP_API_URL || `${BACKEND_URL}/api`;
